import { render, staticRenderFns } from "./BaseNavDropdownItem.vue?vue&type=template&id=34478884&scoped=true&"
import script from "./BaseNavDropdownItem.vue?vue&type=script&lang=js&"
export * from "./BaseNavDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./BaseNavDropdownItem.vue?vue&type=style&index=0&id=34478884&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34478884",
  null
  
)

export default component.exports